import { useEffect, useState } from 'react';
import { useHttpClient } from '../security/hooks/axiosProvider';

export const useCollection = () => {
  const httpClient = useHttpClient();
  const [collectionData, setCollectionData] = useState([]);
  const [cacheCollection, setCacheCollection] = useState([]);

  useEffect(() => {
    const fn = async () => {
      httpClient.current?.get(`/api/production/all`).then((response) => {
        const listOf = response.data
          .reduce((acc, item) => {
            const sub = item.subActivity;
            const activity = sub.activity;
            const activityId = activity.id;
            const subActivityId = sub.id;
            const productionId = item.id;
            const productionName = item.name;
            const activityName = activity.name;
            const subActivityName = sub.name;

            if (!acc[activityId]) {
              acc[activityId] = {
                id: activityId,
                name: activityName,
                subActivities: [],
              };
            }

            if (!acc[activityId].subActivities[subActivityId]) {
              acc[activityId].subActivities[subActivityId] = {
                id: subActivityId,
                name: subActivityName,
                productions: [],
              };
            }

            acc[activityId].subActivities[subActivityId].productions.push({
              id: productionId,
              name: productionName,
            });

            return acc;
          }, [])
          .map((item) => ({ ...item, subActivities: item.subActivities.filter((sub) => sub) }))
          .filter((item) => item);

        setCollectionData(listOf);
        setCacheCollection(response.data);
      });
    };
    fn();
  }, [httpClient]);

  return { collectionData, cacheCollection, setCacheCollection };
};
